<template>
  <section>
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <el-form-item label="分公司:" prop="departmentId">
        <TenantCustomersSelectVue
          v-model="dataForm.departmentId"
          style="width: 220px"
        ></TenantCustomersSelectVue>
      </el-form-item>
      <el-form-item label="客户名称:">
        <el-input
          v-model="dataForm.key"
          placeholder="请输入客户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="密钥:">
        <el-select v-model="dataForm.hasAppkey" placeholder="请选择" clearable>
          <el-option label="已创建" :value="true"> </el-option>
          <el-option label="未创建" :value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户ID:">
        <el-input
          v-model="dataForm.MchId"
          placeholder="请输入商户ID"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-permission="['/Custom/Custom/Search']"
          @click="getDataList()"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-permission="['/Custom/Custom/Add']"
          @click="addOrUpdateHandle()"
          >新增</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          @click="rechrageexportHandle()"
          v-permission="['/Custom/Custom/Add']"
          icon="cloud-upload"
          type="primary"
          >导出</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          @click="setMuchFilterLeavel()"
          v-permission="['/Custom/Custom/Add']"
          type="primary"
          >批量设置过滤</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="dataList"
      v-loading="dataListLoading"
      ref="table"
      class="custom-tbl"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="DepartmentName"
        label="组织架构"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="left"
        prop="Name"
        label="客户名称"
        show-overflow-tooltip
        width="300px"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="FilterTotalCount"
        label="余额"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        prop="MchId"
        label="商户ID"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        prop="FilterLevel"
        label="过滤等级"
        show-overflow-tooltip
      >
        <template scope="scope">
          <el-link type="primary">{{
            scope.row.FilterLevel == "Level1"
              ? "等级1"
              : scope.row.FilterLevel == "Level2"
              ? "等级2"
              : scope.row.FilterLevel == "Level3"
              ? "等级3"
              : ""
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="Remark"
        label="备注"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="450">
        <template scope="scope">
          <el-button
            size="small"
            @click="retCrmAcc(scope.row.Id)"
            v-permission="['/api/CRM/User']"
            >CRM帐号</el-button
          >
          <el-button
            size="small"
            @click="addFilterateHistory(scope.row.Id)"
            v-permission="['/Custom/Custom/RechargeHistory']"
            >充值记录</el-button
          >
          <el-button
            size="small"
            @click="setFilterLeavel(scope.row.Id, scope.row.FilterLevel)"
            v-permission="['/Custom/Custom/setFilterLeavel']"
            type="primary"
            >设置过滤等级</el-button
          >

          <el-dropdown
            trigger="hover"
            v-permission="[
              '/Custom/Custom/GetKey',
              '/Custom/Custom/Edit',
              '/Permission/Permission/ReSetLogin',
              '/Custom/Custom/Delete',
            ]"
          >
            <span class="el-dropdown-link">
              更多功能<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-permission="['/Custom/Custom/GetKey']"
                @click.native="getKey(scope.row.Id)"
                >获取key</el-dropdown-item
              >
              <el-dropdown-item
                v-permission="['/Custom/Custom/Edit']"
                @click.native="addOrUpdateHandle(scope.row.Id)"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item
                v-permission="['/Permission/Permission/ReSetLogin']"
                @click.native="ReSetLogin(scope.row.Id)"
                >重置登录状态</el-dropdown-item
              >
              <el-dropdown-item
                v-permission="['/Custom/Custom/Delete']"
                @click.native="deleteHandle(scope.row.Id)"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
      :current-page="page"
      :page-sizes="pageSizes"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float: right; margin-top: 15px"
    >
    </el-pagination>
    <addOrUpdate ref="addOrUpdate" @ok="query"></addOrUpdate>
    <rechargeHistory
      ref="rechargeHistory"
      @addFilterate="addFilterate"
    ></rechargeHistory>
    <recharge ref="recharge" @ok="rechargeOK"></recharge>
    <SetFilterLeavelVue ref="setFilterLeavel" @ok="query"></SetFilterLeavelVue>
    <CustomAppkey ref="customAppkey" @ok="query"></CustomAppkey>
    <CrmAcc ref="crmAcc"></CrmAcc>
    <MuchSetFilterLeavel
      ref="MuchSetFilterLeavel"
      @ok="query"
    ></MuchSetFilterLeavel>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/CustomAddOrUpdate.vue";
import recharge from "./components/Recharge.vue";
import rechargeHistory from "./components/RechargeHistory.vue";
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
import SetFilterLeavelVue from "./components/SetFilterLeavel.vue";
import CustomAppkey from "./CustomAppkey.vue";
import CrmAcc from "./components/CrmAcc.vue";
import MuchSetFilterLeavel from "./components/MuchSetFilterLeavel.vue";
export default {
  components: {
    addOrUpdate,
    recharge,
    rechargeHistory,
    TenantCustomersSelectVue,
    SetFilterLeavelVue,
    CustomAppkey,
    CrmAcc,
    MuchSetFilterLeavel,
  },
  mixins: [viewModule],
  data() {
    return {
      tenantArr: [], //分公司列表
      dataForm: {
        key: "",
        departmentId: "",
        hasAppkey: "",
        MchId: "",
      },
      mixinViewModuleOptions: {
        requestMethod: "get",
        getDataListIsPage: true,
        getDataListURL: "/api/Common/Get",
        deleteURL: "/api/CustomerCompany/Delete",
        rechrageURL: "/api/CustomerCompany/ExportRechargeList",
        resetloginURL: "/api/Login/ReSetLogin",
      },
    };
  },
  created() {
    this.getTenantArr();
  },
  methods: {
    ReSetLogin(id) {
      this.$http({
        url: "/api/Login/ReSetLogin?id=" + id,
        method: "get",
      }).then((res) => {
        this.$message({
          message: res.msg || "重置成功",
          type: "success",
          duration: 1500,
          onClose: () => {
            this.query();
          },
        });
      });
    },
    //改变部门id
    changeTCS(e) {
      this.dataForm.departmentId = e[e.length - 1];
    },
    //设置过滤等级
    setFilterLeavel(id, FilterLevel) {
      this.$refs.setFilterLeavel.init(id, FilterLevel);
    },
    //设置过滤等级
    setMuchFilterLeavel() {
      this.$refs.MuchSetFilterLeavel.init();
    },
    getTenantArr() {
      this.$http({
        url: "/api/TenantManager/GetAll",
        method: "get",
      }).then((res) => {
        this.tenantArr = res.data.response;
      });
    },
    copyToClipboard(text) {
      // 新的API支持检测
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message.success("复制成功!");
          },
          () => {
            this.$message.error("复制失败！");
          }
        );
      } else {
        // 创建输入框元素
        let oInput = document.createElement("input");
        // 将想要复制的值
        oInput.value = text;
        // 页面底部追加输入框
        document.body.appendChild(oInput);
        // 选中输入框
        oInput.select();
        // 执行浏览器复制命令
        document.execCommand("Copy");
        // 弹出复制成功信息
        this.$message.success("复制成功");
        // 复制后移除输入框
        oInput.remove();
      }
    },
    //获取key
    getKey(id) {
      this.$refs.customAppkey.init(id);
    },
    //充值记录
    addFilterateHistory(id) {
      this.$refs.rechargeHistory.init(id);
    },
    //充值过滤次数
    addFilterate(id) {
      this.$refs.recharge.init(id);
    },
    //充值完成
    rechargeOK() {
      this.query();
      this.$refs.rechargeHistory.query();
    },
    //设置crm帐号
    retCrmAcc(id) {
      this.$refs.crmAcc.init(id);
    },
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.el-dropdown-link {
  margin-left: 15px;
  cursor: pointer;
  color: #409eff;
}
</style>